import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import store from '../store'
import {
  getToken,
  getSubsidiaryId,
  getAuthFinanceAccountIds,
  isPharmacyLogin,
  isSubsidiaryLogin
} from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  //console.log(config,'interceptors--data--------')
  let subsidiaryId = getSubsidiaryId()
  if (subsidiaryId != null && subsidiaryId != '') {
    if (config.data != null) {
      config.data.subsidiaryId = subsidiaryId
    }
  }
  if(config != null && config.url != null && (config.url.indexOf('/rpc/order/findPage') >= 0 || config.url.indexOf('/order/searchMedicineOrder') >= 0) ){
    if (isPharmacyLogin() == 1) {
      config.data.subsidiaryId = null
    }
  }
  console.log(config,'interceptors--data--------')
  let authFinanceAccountIds = getAuthFinanceAccountIds()
  console.log(authFinanceAccountIds, 'authFinanceAccountIds--------')
  if (authFinanceAccountIds != null && authFinanceAccountIds.length > 0) {
    if (config != null && config.url != null) {
      if (config.data != null) {
        config.data.authFinanceAccountIds = authFinanceAccountIds
      }
    }
  }
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
